
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";
var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      
      OrderNotes: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchOrderNotes: null,
      OrderNotesSearchMode: false,
      searchModel: "",
      state: state,
    };
  },
  methods: {
    addOrderNotes() {
      console.log("**********####", this.state);
      var data = {
        title: "popups.addOrderNotes",
        inputs: [
        {"model":"note",
"type":"text",
"label":"order_notes.note"},
{"model":"order_id",
"type":"text",
"label":"order_notes.order_id"},
{"model":"delivery_man_id",
"type":"text",
"label":"order_notes.delivery_man_id"},
{"model":"principal_id",
"type":"text",
"label":"order_notes.principal_id"},
{"model":"created_at",
"type":"text",
"label":"order_notes.created_at"},
{"model":"updated_at",
"type":"text",
"label":"order_notes.updated_at"},

        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("order-notes", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editOrderNotes(app) {
      var data = {
        title: "popups.order_notes",
        inputs: [
         {"model":"note",
"type":"text",
"label":"order_notes.note",
"value":app.note
},
    {"model":"order_id",
"type":"text",
"label":"order_notes.order_id",
"value":app.order_id
},
    {"model":"delivery_man_id",
"type":"text",
"label":"order_notes.delivery_man_id",
"value":app.delivery_man_id
},
    {"model":"principal_id",
"type":"text",
"label":"order_notes.principal_id",
"value":app.principal_id
},
    {"model":"created_at",
"type":"text",
"label":"order_notes.created_at",
"value":app.created_at
},
    {"model":"updated_at",
"type":"text",
"label":"order_notes.updated_at",
"value":app.updated_at
},
    
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("order-notes", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    updateOrderNotes(app) {
      var data = {
        title: "popups.editfile",
        inputs: [
        {"model":"note",
"type":"text",
"label":"order_notes.note"},
{"model":"order_id",
"type":"text",
"label":"order_notes.order_id"},
{"model":"delivery_man_id",
"type":"text",
"label":"order_notes.delivery_man_id"},
{"model":"principal_id",
"type":"text",
"label":"order_notes.principal_id"},
{"model":"created_at",
"type":"text",
"label":"order_notes.created_at"},
{"model":"updated_at",
"type":"text",
"label":"order_notes.updated_at"},

        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.emp_id = app.id;
              this.http.do("order-notes", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.OrderNotesSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("order-notes/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "",
        })
        .then((res) => {
          this.OrderNotes = res.data;
          console.log("######## files", this.OrderNotes);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.OrderNotesSearchMode = false;
      this.get(this.page);
    },
   
    getOrderNotes() {
      this.http.get("order-notes").then((res) => {
        this.OrderNotes = res.data;
      });
    },
    deleteOrderNotes(app) {
      var data = {
        title: "popups.deletefile",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("order-notes", app.id).then(() => {
            console.log("############################3");
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("order-notes/paginate", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.OrderNotes = res.data;
          
        });
    },
  },
  created() {
    this.get(1);
    this.getOrderNotes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.order_notes.text')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="OrderNotesSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="addOrderNotes()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
        <th scope='col'>{{$t('order_notes.id')}}
</th><th scope='col'>{{$t('order_notes.note')}}
</th><th scope='col'>{{$t('order_notes.order_id')}}
</th><th scope='col'>{{$t('order_notes.delivery_man_id')}}
</th><th scope='col'>{{$t('order_notes.principal_id')}}
</th><th scope='col'>{{$t('order_notes.created_at')}}
</th><th scope='col'>{{$t('order_notes.updated_at')}}
</th> 
        <th scope='col'>{{$t('order_notes.operations')}}
</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app) in OrderNotes" :key="app" class="text-center">
          <td>{{app.note}}</td><td>{{app.order_id}}</td><td>{{app.delivery_man_id}}</td><td>{{app.principal_id}}</td><td>{{app.created_at}}</td><td>{{app.updated_at}}</td>
          
          <td class="d-flex">
            <a
              class="btn btn-primary mx-1"
              @click="editOrderNotes(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteOrderNotes(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages == 20">
      <!--   Apps  paginate     -->
      <ul class="paginate paginate-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>




